/*
 * Copyright (c) 2022, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/';

const SOLID_BORDER = '1px solid';

export const useToolTipBaseStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoTooltipDark: {
      color: theme.palette.grey[100],
      backgroundColor: theme.palette.secondary.dark,
      borderRadius: theme.spacing(1),
    },
    infoArrowDark: {
      color: theme.palette.secondary.dark,
    },
    infoTooltipLight: {
      color: theme.palette.secondary.dark,
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(1),
    },
    infoArrowLight: {
      color: theme.palette.common.white,
    },
    errorTooltip: {
      border: SOLID_BORDER,
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.light,
      borderRadius: theme.spacing(1),
    },
    errorArrow: {
      border: SOLID_BORDER,
      borderColor: theme.palette.error.main,
      color: theme.palette.error.light,
    },
    warningTooltip: {
      border: SOLID_BORDER,
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.main,
      backgroundColor: theme.palette.warning.light,
      borderRadius: theme.spacing(1),
    },
    warningArrow: {
      border: SOLID_BORDER,
      borderColor: theme.palette.warning.main,
      color: theme.palette.warning.light,
    },
  })
);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    divider: {
      margin: `${theme.spacing(1)}px 0px`,
    },
    buttonLink: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      marginTop: theme.spacing(1.5),
      textDecoration: 'none',
    },
    dividerDark: {
      backgroundColor: theme.palette.grey[100],
    },
    dividerLight: {
      backgroundColor: theme.palette.grey[100],
    },
    exampleContent: {
      fontSize: 12,
      fontWeight: 100,
      margin: `${theme.spacing(1)}px 0px`
    },
    exampleContentDark: {
      color: theme.palette.grey[100],
    },
    exampleContentLight: {
      color: theme.palette.secondary.dark,
    },
  })
);
